import { updateClienteCoitizacion, postNuevoClienteCotizacion, deleteClientesCotizacion } from "../services/serviceUsuarios"
import { deleteCotizacion, getCotizacion, getCotizacionPdf, putAceptarCotizacion } from "../services/cotizacionService"
import { getNoInterestedClients, markAsNoInterested, getInterestedClientAll, getInterestedClients } from "../services/cleinteServices"
const dataInicial = {
    clientes: [],
    clientesAll: [],
    cliente: {},
    update: false,
    vista: 1,
    exito: 0,
    modalCotizador: false,
    clientesPagina: 0,
    clientesRegistros: 10,
    clientesTotal: 0,
    idCliente: 0,
    idCotizacion: 0,
    cotizacion: {},
    listaNoInteresados: [],
    totalNoInteresados: 0,
    paginaNoInteresados: 0,
    registrosNoInteresados: 10,
    modalRegistroCliente: false,
}
const GET_COTIZADOR_ID_COTIZACION = "GET_COTIZADOR_ID_COTIZACION"
const GET_COTIZADOR_CLIENTE_PDF = "GET_COTIZADOR_CLIENTE_PDF"
const MODAL_COTIZADOR_ACTION = "MODAL_COTIZADOR_ACTION"
const ADD_COTIZADOR_CLIENTE_ACTION = "ADD_COTIZADOR_CLIENTE_ACTION"
const GET_COTIZADOR_CLIENTES_ALL_ACTION = "GET_COTIZADOR_CLIENTES_ALL_ACTION"
const GET_COTIZADOR_CLIENTES_ACTION = "GET_COTIZADOR_CLIENTES_ACTION"
const GET_COTIZADOR_CLIENTES_PAGINA_ACTION = "GET_COTIZADOR_CLIENTES_PAGINA_ACTION"
const GET_COTIZADOR_CLIENTES_REGISTROS_ACTION = "GET_COTIZADOR_CLIENTES_REGISTROS_ACTION"
const GET_COTIZADOR_CLIENTES_FILTRO_ACTION = "GET_COTIZADOR_CLIENTES_FILTRO_ACTION"
const DELETE_COTIZADOR_CLIENTE_ACTION = "DELETE_COTIZADOR_CLIENTE_ACTION"
const UPDATE_COTIZADOR_CLIENTE_ACTION = "UPDATE_COTIZADOR_CLIENTE_ACTION"
const DELETE_COTIZADOR_COTIZACION_ACTION = "DELETE_COTIZADOR_COTIZACION_ACTION"
const GET_COTIIZADOR_LISTA_ACTION = "GET_COTIIZADOR_LISTA_ACTION"
const VIEW_COTIIZADOR_ACTION = "VIEW_COTIIZADOR_ACTION"
const TARGET_COTIZADOR_CLIENTE = "TARGET_COTIZADOR_CLIENTE"
const PUT_COTIZADOR_CLIENTES_ACEPTAR_COTIZACION = "PUT_COTIZADOR_CLIENTES_ACEPTAR_COTIZACION"
const GET_COTIZADOR_NO_INTERESADOS_ALL = "GET_COTIZADOR_NO_INTERESADOS_ALL"
const GET_COTIZADOR_NO_INTERESADOS_ALL_PAGINA = "GET_COTIZADOR_NO_INTERESADOS_ALL_PAGINA"
const GET_COTIZADOR_NO_INTERESADOS_ALL_REGISTROS = "GET_COTIZADOR_NO_INTERESADOS_ALL_REGISTROS"
const PUT_COTIZADOR_MARCAR_NO_INTERESADO = "PUT_COTIZADOR_MARCAR_NO_INTERESADO"
const MODAL_COTIZADOR_REGISTRO_CLIENTE = "MODAL_COTIZADOR_REGISTRO_CLIENTE"
export default function cotizadorReducer(state = dataInicial, action) {
    switch (action.type) {
        case MODAL_COTIZADOR_REGISTRO_CLIENTE:
            return { ...state, modalRegistroCliente: action.payload.modalRegistroCliente }
        case GET_COTIZADOR_NO_INTERESADOS_ALL_PAGINA:
            return { ...state, listaNoInteresados: action.payload.listaNoInteresados, totalNoInteresados: action.payload.totalNoInteresados, paginaNoInteresados: action.payload.paginaNoInteresados}
        case GET_COTIZADOR_NO_INTERESADOS_ALL_REGISTROS:
            return { ...state, listaNoInteresados: action.payload.listaNoInteresados, totalNoInteresados: action.payload.totalNoInteresados, registrosNoInteresados: action.payload.registrosNoInteresados }
        case GET_COTIZADOR_NO_INTERESADOS_ALL:
            return { ...state, listaNoInteresados: action.payload.listaNoInteresados, totalNoInteresados: action.payload.totalNoInteresados }
        case PUT_COTIZADOR_MARCAR_NO_INTERESADO:
            return { ...state, exito: action.payload.exito }
        case PUT_COTIZADOR_CLIENTES_ACEPTAR_COTIZACION:
            return { ...state, exito: action.payload.exito }
        case GET_COTIZADOR_ID_COTIZACION:
            return { ...state, cotizacion: action.payload.cotizacion }
        case GET_COTIZADOR_CLIENTE_PDF:
            return {
                ...state,
                exito: action.payload.exito
            }
        case DELETE_COTIZADOR_COTIZACION_ACTION:
            return {
                ...state,
                exito: action.payload.exito
            }
        case UPDATE_COTIZADOR_CLIENTE_ACTION:
            return {
                ...state,
                exito: action.payload.exito
            }
        case DELETE_COTIZADOR_CLIENTE_ACTION:
            return {
                ...state,
                exito: action.payload.exito
            }
        case GET_COTIZADOR_CLIENTES_ALL_ACTION:
            return {
                ...state,
                clientesAll: action.payload.clientesAll
            }
        case GET_COTIZADOR_CLIENTES_FILTRO_ACTION:
            return {
                ...state,
                clientes: action.payload.clientes,
                clientesTotal: action.payload.clientesTotal,
                idCliente: action.payload.idCliente
            }
        case GET_COTIZADOR_CLIENTES_PAGINA_ACTION:
            return {
                ...state,
                clientes: action.payload.clientes,
                clientesTotal: action.payload.clientesTotal,
                clientesPagina: action.payload.clientesPagina,
            }
        case GET_COTIZADOR_CLIENTES_REGISTROS_ACTION:
            return {
                ...state,
                clientes: action.payload.clientes,
                clientesTotal: action.payload.clientesTotal,
                clientesRegistros: action.payload.clientesRegistros
            }
        case MODAL_COTIZADOR_ACTION:
            return { ...state, modalCotizador: action.payload.modalCotizador, update: action.payload.update, idCotizacion: action.payload.idCotizacion }
        case TARGET_COTIZADOR_CLIENTE:
            return { ...state, cliente: action.payload.cliente, vista: action.payload.vista, editar: action.payload.editar }
        case VIEW_COTIIZADOR_ACTION:
            return { ...state, vista: action.payload.vista }
        case GET_COTIIZADOR_LISTA_ACTION:
            return { ...state, cotizaciones: action.payload.cotizaciones }
        case GET_COTIZADOR_CLIENTES_ACTION:
            return { ...state, clientes: action.payload.clientes, clientesTotal: action.payload.clientesTotal }
        case ADD_COTIZADOR_CLIENTE_ACTION:
            return { ...state, exito: action.payload.exito }
        default:
            return state;
    }
}
export const openModalRegistroClienteAction = ({ open }) => (dispatch) => {
    dispatch({
        type: MODAL_COTIZADOR_REGISTRO_CLIENTE,
        payload: {
            modalRegistroCliente: open
        }
    })
}
export const marcarNoInteresadoAction = ({ idCliente }) => async (dispatch) => {
    return await markAsNoInterested({ idCliente }).then(Response => {
        dispatch({
            type: PUT_COTIZADOR_MARCAR_NO_INTERESADO,
            payload: {
                exito: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerNoInteresadosAction = () => async (dispatch, getSate) => {
    const { registrosNoInteresados, paginaNoInteresados } = getSate().cotizador
    return await getNoInterestedClients({ pagina: paginaNoInteresados + 1, registros: registrosNoInteresados }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_NO_INTERESADOS_ALL,
            payload: {
                listaNoInteresados: Response.lCliente,
                totalNoInteresados: Response.Cantidad
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerNoInteresadosPaginaAction = ({ pagina }) => async (dispatch, getSate) => {
    const { registrosNoInteresados } = getSate().cotizador
    return await getNoInterestedClients({ pagina: pagina + 1, registros: registrosNoInteresados }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_NO_INTERESADOS_ALL_PAGINA,
            payload: {
                listaNoInteresados: Response.lCliente,
                totalNoInteresados: Response.Cantidad,
                paginaNoInteresados: pagina,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerNoInteresadosRegistrosAction = ({ registros }) => async (dispatch, getSate) => {
    const { paginaNoInteresados } = getSate().cotizador
    return await getNoInterestedClients({ pagina: paginaNoInteresados + 1, registros: registros }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_NO_INTERESADOS_ALL_REGISTROS,
            payload: {
                listaNoInteresados: Response.lCliente,
                totalNoInteresados: Response.Cantidad,
                registrosNoInteresados: registros,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}

export const aceptarCotizacionAction = ({ IdCotizacion }) => async (dispatch) => {
    return await putAceptarCotizacion({ IdCotizacion: IdCotizacion }).then(Response => {
        dispatch({
            type: PUT_COTIZADOR_CLIENTES_ACEPTAR_COTIZACION,
            payload: {
                exito: Response,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerCotizacionIdAction = ({ IdCotizacion }) => async (dispatch) => {
    return await getCotizacion({ idCotizacion: IdCotizacion }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_ID_COTIZACION,
            payload: {
                cotizacion: Response,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerCotizacionPdf = ({ IdCotizacion }) => async (dispatch) => {
    return await getCotizacionPdf({ IdCotizacion }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_CLIENTE_PDF,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const eliminarCotizacionAction = ({ idCotizacion }) => async (dispatch) => {
    return await deleteCotizacion({ idCotizacion }).then(Response => {
        dispatch({
            type: DELETE_COTIZADOR_COTIZACION_ACTION,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const eliminarClienteCotizadorAction = ({ idCliente }) => async (dispatch) => {
    return await deleteClientesCotizacion({ idCliente }).then(Response => {
        dispatch({
            type: DELETE_COTIZADOR_CLIENTE_ACTION,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerClientesCotizadorAllAction = () => async (dispatch) => {
    return await getInterestedClientAll().then(Response => {
        dispatch({
            type: GET_COTIZADOR_CLIENTES_ALL_ACTION,
            payload: {
                clientesAll: Response,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}

export const filtroClientesCotizadorAction = ({ idCliente }) => async (dispatch) => {
    return await getInterestedClients({ pagina: dataInicial.clientesPagina + 1,  registros: dataInicial.clientesRegistros, idCliente }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_CLIENTES_FILTRO_ACTION,
            payload: {
                clientes: Response.lCliente,
                clientesTotal: Response.Cantidad,
                idCliente: idCliente,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerClientesCotizadorRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { clientesPagina, idCliente } = getSate().cotizador
    return await getInterestedClients({ pagina: clientesPagina + 1, registros: Registros, idCliente }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_CLIENTES_REGISTROS_ACTION,
            payload: {
                clientes: Response.lCliente,
                clientesTotal: Response.Cantidad,
                clientesRegistros: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerClientesCotizadorPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { clientesRegistros, idCliente } = getSate().cotizador
    return await getInterestedClients({ pagina: Pagina + 1, registros: clientesRegistros, idCliente }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_CLIENTES_PAGINA_ACTION,
            payload: {
                clientes: Response.lCliente,
                clientesTotal: Response.Cantidad,
                clientesPagina: Pagina,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerClientesCotizadorAction = () => async (dispatch) => {
    return await getInterestedClients({ pagina: dataInicial.clientesPagina + 1, registros: dataInicial.clientesRegistros, idCliente: dataInicial.idCliente })
    .then(Response => {
        dispatch({
            type: GET_COTIZADOR_CLIENTES_ACTION,
            payload: {
                clientes: Response.lCliente,
                clientesTotal: Response.Cantidad,
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const newClienteCtoizacionAction = ({ EMail, Nombre, Telefono }) => async (dispatch) => {
    return await postNuevoClienteCotizacion({ EMail, Nombre, Telefono }).then(Response => {
        dispatch({
            type: ADD_COTIZADOR_CLIENTE_ACTION,
            payload: {
                exito: true
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })

}
export const updateClienteCtoizacionAction = ({ idCliente, EMail, Nombre, Telefono }) => async (dispatch) => {
    return await updateClienteCoitizacion({ idCliente, EMail, Nombre, Telefono }).then(Response => {
        dispatch({
            type: UPDATE_COTIZADOR_CLIENTE_ACTION,
            payload: {
                exito: true
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })

}
export const modalViewCotizadorAction = ({ open, update = false, idCotizacion = 0 }) => (dispatch) => {
    dispatch({
        type: MODAL_COTIZADOR_ACTION,
        payload: {
            modalCotizador: open,
            update,
            idCotizacion
        }
    })
}
export const targetClienteAction = ({ cliente, vista, editar }) => (dispatch) => {
    dispatch({
        type: TARGET_COTIZADOR_CLIENTE,
        payload: {
            cliente,
            vista,
            editar
        }
    })
}